(function() {
  // ---------------------------------------------------------------------------
  // Direct add-to-cart for single-variant product cards (no modal).
  // On a card rendered with [data-sales-product-add-to-cart] + data-sales-variant-id,
  // clicking the .product-card-button adds that variant straight to the cart and
  // refreshes the cart drawer via the cart:update event. Clicking anywhere else on
  // the card falls through to the wrapper's link and navigates to the product page.
  // Used by the sales grids AND the cart-drawer upsells.
  // Loaded globally in the header so it is available on every page without
  // pulling in the full sales-product-modal.js. The window guard keeps it a
  // single registration even if sales-product-modal.js is also present.
  // ---------------------------------------------------------------------------
  function salesDirectAddCartUrl() {
    return window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url
      ? window.Theme.routes.cart_add_url
      : '/cart/add.js';
  }

  function salesDirectOpenCartDrawer() {
    const cartDrawer =
      document.querySelector('#header-component .wc-header-cart-source cart-drawer-component') ||
      document.querySelector('#header-component cart-drawer-component') ||
      document.querySelector('cart-drawer-component');

    if (!cartDrawer) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    const cartTrigger = cartDrawer.querySelector('[data-testid="cart-drawer-trigger"]');
    if (cartTrigger instanceof HTMLElement) {
      cartTrigger.click();
    }
  }

  function salesDirectAddToCart(trigger) {
    const variantId = trigger.dataset.salesVariantId;
    if (!variantId || trigger.dataset.salesAdding === 'true') return;

    const button = trigger.querySelector('.product-card-button, .cart-upsell__add');
    const originalText = button ? button.textContent : '';

    trigger.dataset.salesAdding = 'true';
    if (button) button.textContent = 'Adding...';

    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');

    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function(item) {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionIds.push(item.dataset.sectionId);
      }
    });
    if (sectionIds.length) {
      formData.set('sections', sectionIds.join(','));
    }
    formData.set('sections_url', window.location.pathname);

    fetch(salesDirectAddCartUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function(response) {
        return response.json().then(function(body) {
          if (!response.ok || body.status) {
            throw new Error(body.description || body.message || 'Unable to add this item to your cart.');
          }
          return body;
        });
      })
      .then(function(response) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          detail: {
            resource: response || {},
            sourceId: String(variantId),
            data: {
              source: 'product-form-component',
              itemCount: 1,
              productId: trigger.dataset.salesProductId || '',
              variantId: String(variantId),
              sections: response && response.sections ? response.sections : {}
            }
          }
        }));
        window.setTimeout(salesDirectOpenCartDrawer, 160);
      })
      .catch(function(error) {
        console.error(error);
      })
      .finally(function() {
        trigger.dataset.salesAdding = 'false';
        if (button) button.textContent = originalText;
      });
  }

  if (!window.salesProductDirectAddInitialized) {
    window.salesProductDirectAddInitialized = true;

    document.addEventListener('click', function(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const trigger = target.closest('[data-sales-product-add-to-cart]');
      if (!trigger) return;

      // Only the add-to-cart button adds straight to cart. A click anywhere else
      // on the card is left alone so the wrapper's link navigates to the product
      // page. (.product-card-button and .cart-upsell__add only ever live inside
      // the trigger, so a match necessarily belongs to this card.)
      if (!target.closest('.product-card-button, .cart-upsell__add')) return;

      event.preventDefault();
      salesDirectAddToCart(trigger);
    });
  }
})();
